import {ViewType} from "../../gd/const/views/view-type"
import ProjectView from "./project-view"
import ProjectViews from "./project-views"
import ProjectView_Link from "./views/link/link-view"
import ProjectView_Embed from "./views/embed/embed-view"
import ProjectView_Page from "./views/page/page"
import ProjectView_NoViews from "./views/no-views/no-views"
import ProjectView_Form from "./views/form/form-view";
import {ProjectViewConfig} from "./@types";

export default function ProjectViewFactory(viewConfig:ProjectViewConfig, projectViews:ProjectViews):ProjectView {

    const systemType = viewConfig.systemType

    switch (systemType) {
        case ViewType.PROJECT_LINK                      :
            return new ProjectView_Link(viewConfig, projectViews)

        case ViewType.PROJECT_EMBED:
            return new ProjectView_Embed(viewConfig, projectViews)

        case ViewType.PROJECT_PAGE:
            return new ProjectView_Page(viewConfig, projectViews)

        case ViewType.PROJECT_REQUEST_FORMS:
            return new ProjectView_Form(viewConfig, projectViews)

        case ViewType.PROJECT_NO_VIEWS:
            return new ProjectView_NoViews(viewConfig, projectViews)

        default                                         :
            return new ProjectView(viewConfig, projectViews)
    }
}
